// // local
// export const domain = "http://127.0.0.1:8000/api/";
// export const domainV2 = "http://127.0.0.1:8000/api2/";
// export const imageDomain = "http://127.0.0.1:8000/storage/";

// // server test
export const domain = "https://cpcr-api.ksta.co/api/";
export const domainV2 = "http://acaapi.ksta.co/api2/";
export const imageDomain = "https://cpcr-api.ksta.co/storage/";
export const adminDomain = "https://cpcr-admin.ksta.co/";
export const wpDomain = "https://cpcr-wp-uat.kisrasprint.com/";

// // server uat
// export const domain = "https://cpcr-api-uat.kisrasprint.com/api/";
// export const domainV2 = "https://cpcr-api-uat.kisrasprint.com/api2/";
// export const imageDomain = "https://cpcr-api-uat.kisrasprint.com/storage/";
// export const adminDomain = "https://cpcr-admin-uat.kisrasprint.com/";
// export const wpDomain = "https://cpcr-wp-uat.kisrasprint.com/";

// export const domain = "https://cpcr-api-uat.ksta.co/api/";
// export const domainV2 = "https://cpcr-api-uat.ksta.co/api2/";
// export const imageDomain = "https://cpcr-api-uat.ksta.co/storage/";
// export const adminDomain = "https://cpcr-admin-uat.ksta.co/";
// export const wpDomain = "https://cpcr-wp-uat.ksta.co/";

// Server Prod
// export const domain = "https://e-learning-api.thaichildrights.org/api/";
// export const domainV2 = "https://e-learning-api.thaichildrights.org/api2/";
// export const imageDomain =
//   "https://e-learning-api.thaichildrights.org/storage/";
// export const adminDomain = "https://e-learning-admin.thaichildrights.org/";
// export const wpDomain = "https://e-learning.thaichildrights.org/";
